module.exports = __webpack_public_path__ + "img/aria_blanco.12e11ef2.svg";